import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

interface PlaceOnHoldDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (remarks: string) => void;
}

export function PlaceOnHoldDialog({ open, onOpenChange, onConfirm }: PlaceOnHoldDialogProps) {
  const { t } = useTranslation();

  const [remarks, setRemarks] = useState('');

  const handleSubmit = () => {
    onConfirm(remarks);
    setRemarks('');
    onOpenChange(false);
  };

  const handleClose = () => {
    setRemarks('');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t('newcmr.reqstatus.OH.title.message')}</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="remarks">{t('newcmr.reqstatus.comment.label')}</Label>
            <Textarea
              id="remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder={t('newcmr.reqstatus.comment.placeholder')}
              className="min-h-32"
            />
          </div>
        </div>

        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={handleClose}>
            {t('newcmr.reqstatus.OH.close.button')}
          </Button>
          <Button onClick={handleSubmit} className="min-w-24">
            {t('newcmr.reqstatus.OH.save.button')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
